"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Menu_module_scss_1 = __importDefault(require("./Menu.module.scss"));
/**
 * @deprecated MenuList is deprecated. Please use draft-menu instead.
 */
var MenuList = function (props) { return (react_1["default"].createElement("div", { className: Menu_module_scss_1["default"].menuList }, props.children)); };
MenuList.displayName = "MenuList";
exports["default"] = MenuList;
//# sourceMappingURL=MenuList.js.map